import React from 'react';
import styles from './UIGamePlayerInfoBody.module.scss';
import { getColorFromPlayerColor } from '../../UIGamePlayerInfoContainer/UIGamePlayerInfoContainerUtils.ts';
export const UIGamePlayerInfoBody = ({ playerColor, children })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.container,
        style: {
            '--player-color': getColorFromPlayerColor(playerColor)
        }
    }, children);
